import { pathOr } from 'ramda';
import reduceReducers from 'reduce-reducers';

import { createEntitiesReducer } from 'modules/common/redux';

import { types } from './actions';

const initialState = {
  contactId: null,
  entities: {},
};

const entitiesReducer = createEntitiesReducer(
  ['accounts', 'contacts'],
  [types.CONTACT_RECEIVE],
);

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.CONTACT_RECEIVE:
      return {
        ...state,
        contactId: payload.result,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.contacts.contactDetails.data;

export const getContact = (state) =>
  pathOr(
    null,
    ['entities', 'contacts', getScope(state).contactId],
    getScope(state),
  );

export const getAccount = (state) =>
  pathOr(
    null,
    ['entities', 'accounts', pathOr(null, ['account'], getContact(state))],
    getScope(state),
  );

export default reduceReducers(entitiesReducer, reducer, initialState);
